import { Controller } from "@hotwired/stimulus";

export default class CompaniesPagedListController extends Controller {
    static targets = [
        "wasImportedFromIzi",
        "canManageOnlyOwnDestinations",
        "companyKind"
    ];

    readonly wasImportedFromIziTarget!: HTMLElement;
    readonly canManageOnlyOwnDestinationsTarget!: HTMLElement;
    readonly companyKindTarget!: HTMLElement;

    connect() {
        var wasImportedFromIziJquery = $(this.wasImportedFromIziTarget);
        var forms = wasImportedFromIziJquery.closest("form") as JQuery<HTMLFormElement>;
        if (!forms || forms.length !== 1) throw new Error("Cannot find enclosing form.")
        var form = forms[0];

        this.wasImportedFromIziTarget.addEventListener("change", () => {
            form.requestSubmit();
        });

        this.canManageOnlyOwnDestinationsTarget.addEventListener("change", () => {
            form.requestSubmit();
        });

        this.companyKindTarget.addEventListener("change", () => {
            form.requestSubmit();
        });

    }
}